import { useRef } from "react"
import { useForm } from "react-hook-form"
import ReCAPTCHA from "react-google-recaptcha"
import isEmail from "validator/lib/isEmail"
import { newsletterSignup } from "@/lib/api/newsletter"
import { useCopy } from "@/lib/contexts/appContext"
import { Spinner } from "@/components/common/loading/spinner"
import styles from "./newsletter.module.css"

export default function Newsletter() {
  const copy = useCopy()
  const { heading, text, placeholder, formText, buttonText, successText } =
    copy.footer.newsletter

  return (
    <div className={styles.newsletter}>
      <div className="inner-wrapper">
        <div className="info">
          <h2>{heading}</h2>
          <p dangerouslySetInnerHTML={{ __html: text }}></p>
        </div>
        <SignupForm
          placeholder={placeholder}
          formText={formText}
          buttonText={buttonText}
          successText={successText}
        />
      </div>
    </div>
  )
}

function SignupForm({
  placeholder = "",
  formText = "",
  buttonText = "",
  successText = ""
}) {
  const recaptchaRef = useRef()
  const siteKey = process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY
  const methods = useForm({
    mode: "all"
  })

  const onSubmit = async ({ email }) => {
    const captcha = await recaptchaRef.current.executeAsync()
    await newsletterSignup(email, captcha)
  }

  return (
    <form className={styles.form} onSubmit={methods.handleSubmit(onSubmit)}>
      <ReCAPTCHA
        className="hidden"
        ref={recaptchaRef}
        size="invisible"
        sitekey={siteKey}
      />
      <input
        className={styles.input}
        type="email"
        {...methods.register("email", {
          required: true,
          validate: (value) => isEmail(value) || "Ange en giltig e-postadress"
        })}
        required
        placeholder={placeholder}
      />
      <div
        className={styles.description}
        dangerouslySetInnerHTML={{ __html: formText }}
      />
      <button
        className={styles.button}
        aria-label={buttonText}
        disabled={!methods.formState.isValid ? "disabled" : ""}
        type="submit">
        {methods.formState.isSubmitSuccessful ? successText : buttonText}
      </button>
      {methods.formState.isSubmitting && (
        <Spinner
          className={styles.spinner}
          sizeClasses="w-8 h-8 border-4"
          borderClass="border-black-50"
          spinColor="#FFFFFF"
        />
      )}
    </form>
  )
}
